export enum ApiEndpoints {
  UserInfo = 'api/UpdateUserDeviceId',
  LogADUser = 'api/log/LogADUser',
  UpdateDevieToken = 'api/users/u',
  UpdateFCMHistory ='api/PushNotification/UpdateFCMHistory',
  UnsubscribeDeviceToken ='api/PushNotification/UnSubscribed',
  GetUserByEmail= 'api/users/getUserByEmail',
}
